export default {  
    argentina:{
        documentoNacionalIdentidade:{
            codigo: "ARDNI",
            atributo: {
                id: "ARDNI.ID"
            }
        }
    }, 
    uruguai:{
        cedulaIdentidade:{
            codigo: "UYCI",
            atributo: {
                id: "UYCI.ID"
            }
        }
    },    
    peru:{
        documentoNacionalIdentidade:{
            codigo: "PEDNI",
            atributo: {
                id: "PEDNI.ID"
            }
        }
    },  
    equador:{
        cedulaIdentidade:{
            codigo: "ECCI",
            atributo: {
                id: "ECCI.ID"
            }
        }
    },       
    mexico:{
        registroFederalContribuinte:{
            codigo: "MXRFC",
            atributo: {
                id: "MXRFC.ID"
            }
        },
        chaveUnicaRegistroPopulacao:{
            codigo: "MXCURP",
            atributo: {
                id: "MXCURP.ID"
            }
        }        
    },
    estadosUnidos:{
        socialSecurityNumber:{
            codigo: "USSSN",
            atributo: {
                id: "USSSN.ID"
            }
        }       
    },
    brasil:{
        cadastroPessoaFisica:{
            codigo: "BRCPF",
            atributo: {
                id: "BRCPF.ID"
            }
        },
        cadastroPessoaJuridica:{
            codigo: "BRCNPJ",
            atributo: {
                id: "BRCNPJ.ID"
            }
        }        
    }, 
    colombia:{
        cedulaIdentidade:{
            codigo: "COCI",
            atributo: {
                id: "COCI.ID"
            }
        }
    },   
    costaRica:{
        cedulaIdentidade:{
            codigo: "CRCI",
            atributo: {
                id: "CRCI.ID"
            }
        }
    },                   
    panama:{
        cedulaIdentidade:{
            codigo: "PACI",
            atributo: {
                id: "PACI.ID"
            }
        }
    },   
    chile:{
        cedulaIdentidade:{
            codigo: "CLRUN",
            atributo: {
                id: "CLRUN.ID"
            }
        }
    }          
}